/**
 * 立项调研组件常量定义
 */

// 可行性等级选项
export const FEASIBILITY_OPTIONS = [
    { value: 'high', label: '高', color: 'green' },
    { value: 'medium', label: '中', color: 'orange' },
    { value: 'low', label: '低', color: 'red' },
] as const;

// 市场规模选项
export const MARKET_SIZE_OPTIONS = [
    { value: 'large', label: '大市场 (>10亿)' },
    { value: 'medium', label: '中等市场 (1-10亿)' },
    { value: 'small', label: '小市场 (<1亿)' },
    { value: 'niche', label: '利基市场' },
] as const;

// 市场趋势选项
export const MARKET_TREND_OPTIONS = [
    { value: 'growing', label: '📈 增长中' },
    { value: 'stable', label: '➡️ 稳定' },
    { value: 'declining', label: '📉 下降中' },
] as const;

// 立项建议选项
export const RECOMMENDATION_OPTIONS = [
    { value: 'approved', label: '✅ 建议立项' },
    { value: 'pending', label: '⏳ 需进一步调研' },
    { value: 'rejected', label: '❌ 不建议立项' },
] as const;

export type FeasibilityValue = typeof FEASIBILITY_OPTIONS[number]['value'];
export type MarketSizeValue = typeof MARKET_SIZE_OPTIONS[number]['value'];
export type MarketTrendValue = typeof MARKET_TREND_OPTIONS[number]['value'];
export type RecommendationValue = typeof RECOMMENDATION_OPTIONS[number]['value'];
